import { buildApiUrl, RequestHandler } from '../request-handler'

export async function fetchApiAdmin(path: string, init?: RequestInit): Promise<Response> {
  const normalizedPath = path.replace(/^\//, '')
  const url = buildApiUrl(`admin/${normalizedPath}`)

  console.log('[SDS Consumer API] Request:', { method: init?.method || 'GET', url: url.toString() })

  return RequestHandler({
    method: init?.method,
    url,
    headers: init?.headers,
    body: init?.body,
    signal: init?.signal ?? undefined,
  })
}

export async function readResponseText(response: Response): Promise<string> {
  try {
    return await response.text()
  } catch {
    return ''
  }
}

export async function throwIfNotOk(response: Response): Promise<void> {
  if (response.ok) return

  const bodyText = await readResponseText(response)
  const statusLine = `${response.status} ${response.statusText}`.trim()
  const message = bodyText ? `${statusLine}\n${bodyText}` : statusLine

  console.error('[SDS Consumer API Error]', {
    status: response.status,
    statusText: response.statusText,
    url: response.url,
    body: bodyText,
  })

  throw new Error(message)
}
